function safeStringifyErrorEvent(value: unknown): string {
  const seen = new WeakSet<object>()

  try {
    return JSON.stringify(value, (key, val) => {
      // `target`/`currentTarget` on the polyfill's event objects point back
      // to the EventSourcePolyfill instance itself (internal closures, XHR
      // state) — noisy and not useful for diagnosing the error shape.
      if (key === 'target' || key === 'currentTarget') return undefined
      if (typeof val === 'function') return undefined

      if (typeof val === 'object' && val !== null) {
        if (seen.has(val)) return '[Circular]'
        seen.add(val)
      }

      return val
    })
  } catch (error) {
    return `[unstringifiable errorEvent: ${(error as Error).message}]`
  }
}

export { safeStringifyErrorEvent }
